import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { PromoCodeValidation } from '@/shared/domain'
import type { ValidatePromoCode } from '@/modules/auth/use-cases'

export class EdgeValidatePromoCodeRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: ValidatePromoCode = async (params) => {
    const search = new URLSearchParams({ code: params.code })
    const request: HttpRequest<never> = {
      url: `/subscriptions/validate-promo?${search.toString()}`,
    }
    return this.httpClient.get<PromoCodeValidation>(request)
  }
}
